<template>
  <Dialog ref="dialog"
          width="640px"
          icon="fas fa-truck"
          @confirm="checkOrders"
          @closed="closeDialogTabs"
          :show-confirm="true"
          :title="`Patente: ${plate}`">
    <el-tabs type="border-card" v-model="mode">
      <el-tab-pane label="TIM" name="tim">
        <el-input type="textarea"
                  :rows="6"
                  placeholder="124005957777, 124005958888 ..."
                  v-model="textarea">
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="AGREGAR" name="add">
        <el-input type="textarea"
                  :rows="6"
                  placeholder="124005957777, 124005958888 ..."
                  v-model="textarea">
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="ELIMINAR" name="del">
        <el-input type="textarea"
                  :rows="6"
                  placeholder="124005957777, 124005958888 ..."
                  v-model="textarea">
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="AGREGAR LPN" name="addLpn">
        <el-input type="textarea"
                  :rows="6"
                  placeholder="316400000000272688, 316400000000272689, 316400000000272690..."
                  v-model="textarea">
        </el-input>
      </el-tab-pane>
      <el-tab-pane label="ELIMINAR LPN" name="deleteLpn">
        <el-input type="textarea"
                  :rows="6"
                  placeholder="316400000000272688, 316400000000272689, 316400000000272690..."
                  v-model="textarea">
        </el-input>
      </el-tab-pane>
    </el-tabs>
  </Dialog>
</template>

<script>
import Dialog from '../base/Dialog.vue';

export default {
  name: 'DialogChange',
  components: {
    Dialog,
  },
  data() {
    return {
      textarea: '',
      mode: 'tim',
      plate: '-',
      routeId: NaN,
    };
  },
  methods: {
    checkOrders() {
      if (this.mode == 'addLpn' || this.mode == 'deleteLpn') {
        const listLpn = this.textarea.trim().split(',')
          .reduce((acc, s) => acc.concat(s.split('\n')), [])
          .reduce((acc, s) => acc.concat(s.split('\r')), [])
          .filter(s => s.length > 0);

        if (listLpn.length === 0) {
          this.$refs.dialog.loading(false);
          this.$notify.warning({
            title: 'Acción incorrecta',
            message: 'No hay LPNs para modificar.',
          });
        } else {
          this.$refs.dialog.visible(false);
          this.$emit(this.mode, this.routeId, listLpn);
        }
        return;
      }


      const text = this.textarea.trim().split(',')
        .reduce((acc, s) => acc.concat(s.split('\n')), [])
        .reduce((acc, s) => acc.concat(s.split('\r')), [])
        .filter(s => s.length > 0)
        .map(s => parseInt(s.trim(), 10))
        // eslint-disable-next-line no-restricted-globals
        .filter(i => !isNaN(i));
      if (this.mode !== 'tim' && text.length === 0) {
        this.$refs.dialog.loading(false);
        this.$notify.warning({
          title: 'Acción incorrecta',
          message: 'No hay subórdenes para modificar',
        });
      } else {
        this.$refs.dialog.visible(false);
        this.$emit(this.mode, this.routeId, text);
      }
    },
    closeDialogTabs() {
      this.$emit('closed', true);
    },
    reset() {
      this.$refs.dialog.visible(false);
      Object.assign(this, {
        textarea: '',
        mode: 'tim',
        plate: '-',
        routeId: NaN,
      });
    },
    showChangeDialog(route) {
      this.reset();
      this.routeId = route.id;
      if (route.vehicle) this.plate = route.vehicle.plate;
      this.$refs.dialog.visible(true);
    },
  },
};
</script>

<style lang="scss" scoped>
  .btnSearch{
    height: 40px;
  }
  .rowRoutePatent{
    display: table;
    margin-top: -20px;
    height:20px;
    margin-left: 30px;
    margin-bottom: 0px;
    text-align: left;
  }
  .el-icon-truck {
    margin-right: 10px;
    font-size: 20px;
    color: #c0c4cc;
    display: table-cell;
    vertical-align: middle;
  }
  .titleStyle {
    font-size: 11px;
    color: #707070;
    text-transform: uppercase;
    margin: 0 30px 0 0;
    font-weight: normal;
  }
  .titleStyleCV {
    font-size: 12px;
    color: #9B9B9B;
    text-transform: uppercase;
    margin: 15px 0 5px 50px;
    font-weight: normal;
    text-align: left;
  }
  .contentMap {
    width: 100%;
    height: 30vh !important;
  }
  .el-input__inner{
    width: 200px;
  }
  el-form el-form--inline{
    text-align: left;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 14px;
    text-align: left;
    margin: 0 0 1.2em;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .input {
    margin: 8px 0 16px 0;
  }
  .dialogText {
    width: 85%;
    margin: auto;
    .focus {
      display: block;
    }
  }
  .dialogItem {
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 20px;
    .focus {
      display: block;
    }
  }
  .btnBottom {
    margin-top: 10px;
    float: right;
  }
  .tableStyle {
    box-sizing: border-box;
    overflow: hidden;
  }
  .grey {
    background-color: #606266;
    align-self: flex-end;
    height: 40px;
  }
  .titleStyleNumRoutes {
    font-size: 13px;
    color: #AAD500;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 10px 0px;
  }
  .linkStyle {
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .dialogTitle {
    padding: 0 40px;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-edit {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-warning {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-truck {
      color: #AAD500;
      font-size: 1.2em;
      margin-right: 0.5em;
      padding-right: 5px;
      vertical-align: baseline;
    }
  }
  .dialogRec {
    padding: 0 40px;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 700;
    margin: 30px 0 0 0;
  }
  .dialogSub {
    padding: 10px 40px 0 0;
    text-align: left;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 500;
    margin-top: 0;
    .el-icon-circle-plus {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-remove {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-success {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .ordersListStyleDialog {
      font-size: 11px;
      text-align: left;
    }
    .dialogTotalTim {
      padding: 10px 40px 0 0;
      text-align: center;
      font-size: 1em;
      text-transform: uppercase;
      font-weight: 800;
      margin-top: 0;
    }
  }
  .dialogError {
    padding: 10px 40px 0 0px;
    text-align: left;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-error {
      color: #f4511e;
      font-size: 1.2em;
      margin: 0 0.5em 0 0;
    }
  }
  .totalItemTim{
    color: white;
    font-size: 10px;
    background: #F5A623;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    text-align: center;
    width: 2.4em;
  }
  .totalItemTimSuss{
    color: white;
    font-size: 12px;
    background: #AAD500;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    margin-top: 5px;
    text-align: center;
    width: 2.4em;
  }
  .ordersListStyleDialog{
    margin-left: 10px;
  }
  .dialogItemSuss{
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 30px;
    .focus {
      display: block;
    }
  }
  .clickeable {
    font-size: 7px;
    padding-top: 1px;
    margin-right: 3px;
    height: 23px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
  }
  .clickeable:hover {
    color: #AAD500;
    animation: none;
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  td {
    padding: 2px 0px !important;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -2px;
  }
  .spCla {
    font-size: 10px;
    color: #707070;
    vertical-align: middle;
    margin-left: 6px;
  }

  .rotate-1 {
    webkit-animation: rotating 5s linear infinite;
    animation: rotating 5s linear infinite;
  }

  .el-icon-refresh-right {
    padding: 3px;
    color: white;
    border-radius: 50%;
    background-color: #09558f;
  }

  .refresh-send {
    font-size: 15px;
    color: #AAD500;
    background-color: transparent;
  }
</style>
